export type Unit = { readonly _unit: unique symbol };

export const Unit = { value: {} as Unit };
